import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { finalize } from 'rxjs/operators';
import { TieService } from '../../_core/services/tie.service';
import { Tie } from '../../_shared/models/tie.model';

@Component({
  standalone: false,
    selector: 'app-tie-selector',
    templateUrl: './tie-selector.component.html',
    styleUrls: ['./tie-selector.component.scss'],
})
export class TieSelectorComponent implements OnInit {
    ties: Tie[] = [];
    selectedTies: string[] = [];

    page = 0;
    getMoreTies: boolean;
    isLoading: boolean;

    constructor(
        private tieService: TieService,
        private modalController: ModalController
    ) { }

    ngOnInit() {
        this.isLoading = true;
        this.getTies();
    }

    doInfinite(infiniteScroll) {
        this.page++;
        this.getTies();
        setTimeout(() => {
            infiniteScroll.target.complete();
        }, 1500);
    }

    getTies(refresher?) {
        const paginationConfig = {
            page: this.page,
            sort: -1,
            limit: 20,
            type: 'ties'
        };

        this.tieService
            .getMyTies(paginationConfig)
            .pipe(finalize(() => {
                this.isLoading = false;
                if (refresher) refresher.detail.complete();
            }))
            .subscribe(res => {
                res.data.forEach(tie => {
                    this.ties.push(tie);
                });

                if (res.data.length < 10) {
                    this.getMoreTies = false;
                } else {
                    this.getMoreTies = true;
                }
            });
    }

    selectTie(ev, index) {
        if (ev.detail.checked) {
            this.selectedTies.push(this.ties[index]._id);
        } else {
            const tieIndex = this.selectedTies.findIndex(tieId => tieId === this.ties[index]._id);
            this.selectedTies.splice(tieIndex, 1);
        }
    }

    selectTies() {
        this.modalController
            .getTop()
            .then(
                modal => modal.dismiss(this.selectedTies)
            );
    }

    getTeamName(tie: Tie, sideNumber: number): string {
        if (tie.sides[sideNumber - 1].team) {
            return tie.sides[sideNumber - 1].team.name;
        } else {
            return 'Deleted team';
        }
    }

}
